<template>
    <div class="container">
        <h1>Configure "{{device['name']}}"</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="Info">
                <div class="container has-text-left margin_top_1rem">
                    <b-field :label="'ID: ' + device.id"></b-field>
                    <b-field :label="'Connected via: ' + device['integration_name']"></b-field>
                    <b-field v-if="device.parent_id > 0" :label="'Parent: ' + device['parent_device_name']"></b-field>
                    <b-field label="Name">
                        <b-input v-model="deviceName" required></b-input>
                    </b-field>
                    <b-field label="Internal ID">
                        <b-input v-model="deviceInternalId"></b-input>
                    </b-field>
                    <div v-if="device.childDevices.length > 0" class="margin_top_1rem margin_bottom_1rem">
                        <app-child-device-list :devices="device.childDevices"></app-child-device-list>
                    </div>
                    <b-button label="Modify" type="is-primary" @click="handleModify"
                              :disabled="!validFields()"></b-button>
                    <b-button label="Back" type="is-danger" class="margin_left_1rem" @click="handleAbort"
                              outlined></b-button>
                </div>
            </b-tab-item>
            <b-tab-item label="Topics">
                <div class="container has-text-left margin_top_1rem margin_bottom_1rem">
                    <b-field label="Copy topics from:">
                        <b-select v-model="srcDeviceId">
                            <option :value="0">choose device...</option>
                            <option
                                    v-for="device in srcDeviceList"
                                    :key="device.id"
                                    :value="device.id"
                            >{{device.name}}</option>
                        </b-select>
                    </b-field>
                    <div class="buttons" v-if="srcDeviceId > 0">
                        <b-button type="is-primary" @click="handleCopyTopics">Copy topics</b-button>
                    </div>
                    <hr/>
                </div>
                <div class="container has-text-left margin_top_1rem margin_bottom_1rem">
                    <b-field label="Topic">
                        <b-input v-model="topic" required></b-input>
                    </b-field>
                    <b-field label="Description">
                        <b-input v-model="topicDescription" required></b-input>
                    </b-field>
                    <b-field label="Filter Min">
                        <b-input v-model="topicFilterMin"></b-input>
                    </b-field>
                    <b-field label="Filter Max">
                        <b-input v-model="topicFilterMax"></b-input>
                    </b-field>
                    <b-button label="Add" type="is-success" :disabled="!validFieldsForTopic()" @click="handleAddDeviceTopic"></b-button>
                </div>
                <app-topic-list :topics="topicList" :deviceId="device.id"></app-topic-list>
            </b-tab-item>
            <b-tab-item label="States">
                <app-state-list :states="stateList"></app-state-list>
            </b-tab-item>
            <b-tab-item label="Endpoints">
                <div class="container has_text_left margin_top_1rem">
                    <div style="display: flex; justify-content: flex-end;" v-if="!addEndpointFormToggled">
                        <b-button type="is-primary" @click="addEndpointFormToggled = !addEndpointFormToggled" class="is-small">Add Endpoint</b-button>
                    </div>
                    <app-add-device-endpoint v-else
                                             :deviceId="device.id"
                                             :onAbort="() => {addEndpointFormToggled = !addEndpointFormToggled;}"></app-add-device-endpoint>
                    <app-endpoint-list
                            :data="device.endpoints"
                            :deviceId="device.id"
                    ></app-endpoint-list>
                </div>
            </b-tab-item>
        </b-tabs>

    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import ChildDeviceList from '../components/configure/ChildDeviceList';
  import TopicList from '../components/configure/TopicList';
  import StateList from '../components/configure/StateList';
  import AddDeviceEndpoint from '../components/configure/AddDeviceEndpoint';
  import EndpointList from '../components/configure/EndpointList';

  export default {
    name: "screenconfiguredevice",
    components: {
      BButton,
      BInput,
      BField,
      appChildDeviceList: ChildDeviceList,
      appTopicList: TopicList,
      appStateList: StateList,
      appAddDeviceEndpoint: AddDeviceEndpoint,
      appEndpointList: EndpointList
    },
    data() {
      return {
        activeTab: 0,
        deviceName: '',
        deviceInternalId: 0,
        deviceRoomId: 0,
        topic: '',
        topicDescription: '',
        topicFilterMin: '',
        topicFilterMax: '',
        addEndpointFormToggled: false,
        srcDeviceId: 0
      };
    },
    watch: {
      device(v) {
        this.prefillData(v);
      }
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('devices', ['deviceById', 'devices']),
      ...mapGetters('rooms', ['rooms']),
      ...mapGetters('mqtt', ['valueForTopic']),
      device() {
        return this.deviceById(this.$route.params.id);
      },
      srcDeviceList() {
        return this.devices.filter(item => {
          return parseInt(item.id) !== parseInt(this.$route.params.id);
        });
      },
      availableRooms() {
        const arr = [
          {id: 0, name: '- none -'}
        ];

        if (this.rooms) {
          this.rooms.forEach(room => {
            arr.push(room);
          });
        }

        return arr;
      },
      topicList() {
        const arr = [];

        if (this.device && this.device.data) {
          Object.keys(this.device.data.topics).forEach(topic => {
            const item = this.device.data.topics[topic];
            arr.push({
              ...item,
              id: item['topicId'],
              topic: topic,
              hftTopic: this.hftTopic(topic),
              hftFilters: item['filters'] ? JSON.stringify(item['filters']) : '-'
            });
          });
        }

        return arr;
      },
      stateList() {
        const arr = [];

        if (this.device && this.device.data) {
          Object.keys(this.device.data.states).forEach(stateName => {
            const item = this.device.data.states[stateName];
            arr.push({
              ...item,
              name: stateName
            });
          });
        }

        return arr;
      }
    },
    methods: {
      ...mapActions('devices', ['modifyDevice', 'addDeviceTopic', 'copyDeviceTopics']),
      prefillData(source) {
        this.deviceName = source.name;
        this.deviceInternalId = source.internal_id;
        this.deviceRoomId = source.room_id;
      },
      validFields() {
        if (this.deviceName.length < 1) {
          return false;
        }

        return true;
      },
      validFieldsForTopic() {
        const regexTopic = /\w+\/.+/gm;
        if (this.topic.length < 1) {
          return false;
        }
        if (!regexTopic.exec(this.topic)) {
          return false;
        }

        if (this.topicDescription.length < 1) {
          return false;
        }

        return true;
      },
      resetAddTopicFields() {
        this.topic = '';
        this.topicDescription = '';
        this.topicFilterMin = '';
        this.topicFilterMax = '';
      },
      hftTopic(topic) {
        const splits = topic.split(/\//);
        if (splits.length >= 2) {
          const len = splits.length;

          return `.../${splits[len - 2]}/${splits[len - 1]}`;
        }

        return topic;
      },
      handleModify() {
        this.modifyDevice({
          id: this.device.id,
          deviceName: this.deviceName,
          deviceInternalId: this.deviceInternalId,
          deviceRoomId: this.deviceRoomId
        });
        this.resetAddTopicFields();
      },
      handleAddDeviceTopic() {
        this.addDeviceTopic({
          id: this.device.id,
          topic: this.topic,
          description: this.topicDescription,
          filterMin: this.topicFilterMin,
          filterMax: this.topicFilterMax
        });
      },
      handleAbort() {
        this.$router.push('/configure/devices');
      },
      handleCopyTopics() {
        this.copyDeviceTopics({
          id: this.device.id,
          srcDeviceId: this.srcDeviceId
        });
        this.srcDeviceId = 0;
      }
    },
    mounted() {
      if (this.device) {
        this.prefillData(this.device);
      }
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_left_1rem {
        margin-left: 1rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }

    .margin_bottom_1rem {
        margin-bottom: 1rem;
    }
</style>